/**
 * @prettier
 */

import { useState, lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Context } from './context';

const Profile = lazy(() => import('./profile'));
const Loading = () => <p>Loading ...</p>;

const Main = () => {
	const [homePageTab, setHomePageTab] = useState<number>(1);
	const updateHomePageTab = (newTab: number) => setHomePageTab(newTab);

	return (
		<Context.Provider
			value={{
				homePageTab,
				updateHomePageTab
			}}>
			<Suspense fallback={<Loading />}>
				<Routes>
					<Route path='/' element={<Profile />} />
				</Routes>
			</Suspense>
		</Context.Provider>
	);
};

export default Main;
